export default __webpack_public_path__ + "static/media/Armbands of Writhing.6982b104.jpg";